module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-snackbar', {
    attrs: {
      "color": "accent"
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.snackbarIcon))]), _vm._v(_vm._s(_vm.snackbarText))], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [(_vm.jobs.length === 0) ? _c('p', [_vm._v("Outbox is empty")]) : _vm._l((_vm.jobs), function(job) {
    return _c('v-card', {
      key: job.number,
      staticClass: "my-2"
    }, [_c('v-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('h3', [_vm._v(_vm._s(job.JobNo))])]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('h5', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(_vm._f("customerNameFromId")(job.Customer, _vm.customers)) + " " + _vm._s(_vm.imageCount(job).sent) + "/" + _vm._s(_vm.imageCount(job).count) + " images sent")])]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "align-center": "",
        "justify-space-around": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.downloadJob(job.number)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("file_download")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.uploadJob(job.number)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("file_upload")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteJob(job.number)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "error"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.logDialog),
      callback: function($$v) {
        _vm.logDialog = $$v
      },
      expression: "logDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.logDialogTitle))]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.copyLog
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.sendDebugLog
    }
  }, [_vm._v("Send Log")])], 1), _vm._v(" "), _c('v-textarea', {
    ref: "logTextField",
    staticClass: "pt-0",
    attrs: {
      "rows": "10",
      "label": "Log",
      "autofocus": ""
    },
    model: {
      value: (_vm.logDialogLog),
      callback: function($$v) {
        _vm.logDialogLog = $$v
      },
      expression: "logDialogLog"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.logDialogInfo))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "grey darken-2",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.logDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-496279db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Outbox.vue
// module id = 670
// module chunks = 1